/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class EventOccurrence extends DaoModel {
  constructor(guid, name, description, eventGuid, date, posGuidList, color, isPositive) {
    super(guid);
    this.name = name || '';
    this.description = description || '';
    this.eventGuid = eventGuid || '';
    this.date = date || '';
    this.posGuidList = posGuidList || [];
    this.color = color || '';
    this.isPositive = isPositive || true;
  }

  static toInstance(props = {}) {
    return new EventOccurrence(props.guid, props.name, props.description, props.event_guid,
      props.day_date, props.point_of_sale_list, props.event_type_color, props.is_positive);
  }
}
